import Vue from 'vue'
import Router from 'vue-router'
/*引入页面*/
import Index from '@/components/index'
import Main from '@/components/main'
import Top from '@/components/top'
import Left from '@/components/left'
import Desktop from '@/components/desktop'
import Reg from '@/components/reg'
import ErrPage from '@/components/err'

/* 通讯录页面 */
import TxlCont from '@/components/txl/txlcont'
import TxlAdd from '@/components/txl/txladd'
import TxlUpload from '@/components/txl/txlupload'
import TxlUpload2 from '@/components/txl/txlupload2'
import TxlGroup from '@/components/txl/txlgroup'
import TxlEdit from '@/components/txl/txledit'

/* 提醒 */
import Remind from '@/components/kingtime/remind'
import RemindAdd from '@/components/kingtime/remindadd'
import RemindEdit from '@/components/kingtime/remindedit'
import Memorandum from '@/components/kingtime/memorandum'
import MemorandumAdd from '@/components/kingtime/memorandumadd'
import MemorandumAddTX from '@/components/kingtime/memorandumaddtx'
import MemorandumEdit from '@/components/kingtime/memorandumedit'
import MemorandumTXEdit from '@/components/kingtime/memorandumtxedit'
import RemindType from '@/components/kingtime/remindtype'

/* 企业管理 */
import Enterprise from '@/components/enterprise/enterprise'
import EnterPriseUserManage from '@/components/enterprise/enterpriseusermanage'
import EnterPriseXpaySuccess from '@/components/enterprise/enterprisexpaysuccess'

/*短信管理 */
import SmsSend from '@/components/sms/smssend'
import SmsShortSend from '@/components/sms/smsshortsend'
import SmsMo from '@/components/sms/smsmo'
import SmsMtDayLog from '@/components/sms/smsmtdaylog'
import SmsMtDayBeforeLog from '@/components/sms/smsmtdaybeforelog'
import SmsMtLog from '@/components/sms/smsmtlog'
import SmsCheck from '@/components/sms/smscheck'
import SmsSaveBox from '@/components/sms/smssavebox'
import SmsDraftBox from '@/components/sms/smsdraftbox'
import SmsReachNotice from '@/components/sms/smsreachnotice'
import SmsContTxt from '@/components/sms/smsconttxt'
import SmsClassFiy from '@/components/sms/smsclassfiy'
import SmsClassFiyContent from '@/components/sms/smsclassfiycontent'
import SmsGeXing from '@/components/sms/smsgexing'
import SmsTools from '@/components/sms/smstools'
import SmsSign from '@/components/sms/smssign'
import SmsMtSendError from '@/components/sms/smsmtsenderror'
import ShowSmsTxtContent from '@/components/sms/showsmstxtcontent'
import SmsHistory from '@/components/sms/smshistory'
import BindMobile from '@/components/sms/bindmobile'
import SmsShortTask from '@/components/sms/smsshorttask'
import SmsShortVisit from '@/components/sms/smsshortvisit'
import VideoSmsSend from '@/components/sms/videosmssend'
import VideoSmsTemplate from '@/components/sms/videosmstemplate'
import VideoSmsTemplateAdd from '@/components/sms/videosmstemplateadd'
import VideoSmsLog from '@/components/sms/videosmslog'

/*流量 */
import LLRecharge from '@/components/liuliang/llrecharge'
import LLRechargeLog from '@/components/liuliang/llrechargelog'
import LLRechargeDetail from '@/components/liuliang/llrechargedetail'

/*邮件 */
import EmailSend from '@/components/email/emailsend'
import EmailLog from '@/components/email/emaillog'
import EmailConfig from '@/components/email/emailconfig'
import EmailHelp from '@/components/email/emailhelp'
import EmailLogDetail from '@/components/email/emaillogdetail'

/*  点击通话  */
import DialSet from '@/components/dial/dialset'
import DialSend from '@/components/dial/dialsend'
import DialLog from '@/components/dial/diallog'

/** 彩信 */
import MmsSend from '@/components/mms/mmssend'
import MmsCheck from '@/components/mms/mmscheck'
import MmsCheckInfo from '@/components/mms/mmscheckinfo'
import MmsDraft from '@/components/mms/mmsdraft'
import MmsSendLog from '@/components/mms/mmssendlog'
import MmsSave from '@/components/mms/mmssave'

/** 语音验证码 */
import VoiceCodeLog from '@/components/voicecode/voicecodelog'

/* 用户设置 */
import PersonInfo from '@/components/person/personinfo'
import PasswordSet from '@/components/person/passwordset'
import Account from '@/components/person/account'
import InvoiceSet from '@/components/person/invoiceset'
// import InvoiceLog from '@/components/person/invoicelog'
import User106 from '@/components/person/user106'
import ChargeInfo from '@/components/person/chargeinfo'
import UserCoupon from '@/components/person/usercoupon'
import UserPackage from '@/components/person/userpackage'
import UserVoucher from '@/components/person/uservoucher'
import ChargeAccount from '@/components/person/chargeaccount'
import YouHui from '@/components/person/youhui'
import Fee from '@/components/person/fee'
import ChouJiang from '@/components/person/choujiang'
// import QqToken from '@/components/person/qqtoken'
import UserVip from '@/components/person/uservip'

/*顶部,投诉建议,帮助 */
import Message from '@/components/message'
import Kefuindex from '@/components/kefu/kefuindex'
import Kefutop from '@/components/kefu/kefutop'
import Kefuleft from '@/components/kefu/kefuleft'
import Contact from '@/components/kefu/contact'
import Introduce2office from '@/components/kefu/introduce2office'
import Useguide from '@/components/kefu/useguide'
import User_2office from '@/components/2office_user'

/* 发票管理 */
import InvoiceApply from '@/components/invoice/invoiceapply'
import InvoiceInformationManage from '@/components/invoice/invoiceinformationmanage'
import InvoiceAddressManage from '@/components/invoice/invoiceaddressmanage'
import InvoiceLog from '@/components/invoice/invoicelog'

import GetPassword from '@/components/getpassword'
import ShowAllSystemMessage from '@/components/systemmessage/systemmessage'

import PaySuccess from '@/components/paysuccess'
import CheckEmail from '@/components/person/checkemail'

/**QQ 登录 */
import QQLogin from '@/components/qq/qqlogin'
import QQToken from '@/components/qq/qqtoken'
import QQBind from '@/components/qq/qqbind'

/** 二办首页相关页面--产品中心，资费说明，客服中心，关于我们，代理合作 */
import Job_2office from '@/components/shouye/job'
import ProductIntroduction from '@/components/shouye/productintroduction'
import ProductLeft from '@/components/shouye/productleft'
import WSZJ_Introduction from '@/components/shouye/productdescription/wszj_introduction'
import Phone400 from '@/components/shouye/productdescription/400phoneintroduction'
import SmsMmsIntroduction from '@/components/shouye/productdescription/smsmmsintroduction'
import FaxIntroduction from '@/components/shouye/productdescription/faxintroduction'
import ChangHuaBaoIntroduction from '@/components/shouye/productdescription/changhuabaointroduction'
import MeetingIntroduction from '@/components/shouye/productdescription/meetingintroduction'
import VoiceSmsIntroduction from '@/components/shouye/productdescription/voicesmsintroduction'
import ApiIntroduction from '@/components/shouye/productdescription/apiintroduction'
import AboutUs from '@/components/shouye/aboutus'
import AboutUsLeft from '@/components/shouye/aboutusleft'
import Introduction2Office from '@/components/shouye/aboutusdescription/2officeintroduction'
import FeeIndex from '@/components/feeindex'
import TopIndex from '@/components/shouye/topindex'
import YouHuiIndex from '@/components/shouye/youhuiindex'
import ProductAndFunction from '@/components/shouye/aboutusdescription/productandfunction'
import Partners from '@/components/shouye/aboutusdescription/partners'
import ImportantEvents from '@/components/shouye/aboutusdescription/importantevents'
import Kefu from '@/components/shouye/kefu'
import KefuIndexLeft from '@/components/shouye/kefuindexleft'
import UseguideIndex from '@/components/shouye/kefu/useguideindex'
import DaiLiHeZuo from '@/components/shouye/dailihezuo'

import AliPayAuth from '@/components/alipaylogin/alipayauth'
import AliPayLogin from '@/components/alipaylogin/alipaylogin'

/** 短信宝授权登录 */
import albbSmsLogin from '@/components/albbsmslogin/alibaba_sms'
import fyzxLogin from '@/components/fyzxlogin/fyzx_login'

import AliCrmLogin from '@/components/alicrm/alicrmlogin'
import AliCrmReg from '@/components/alicrm/alicrmreg'
import AliCrmBind from '@/components/alicrm/alicrmbind'
import QrCodeImg from '@/components/qrcodeimg'
import MenuTest from '@/components/menu/menutest'

import FaxSend from '@/components/fax/faxsend'
import FaxCheck from '@/components/fax/faxcheck'
import FaxSendLog from '@/components/fax/faxsendlog'
import FaxContTxt from '@/components/fax/faxconttxt'
import ShowFaxTxtContent from '@/components/fax/showfaxtxtcontent'
import AuthenTicationNumber from '@/components/authenticationnumber/authenticationnumber'
import AuthenTicationNumberManage from '@/components/authenticationnumber/authenticationnumbermanage'
import ChargeSeconds400Activity from '@/components/person/chargeseconds400activity'
import Seconds400PaySuccess from '@/components/seconds400paysuccess'
import Seconds400ActivityRecord from '@/components/seconds400activityrecord'

/**云电销 */
import ManageWavFile from '@/components/marketvoice/managewavfile'
import SendMarketVoice from '@/components/marketvoice/sendmarketvoice'
import MarketVoiceDetailBill from '@/components/marketvoice/marketvoicedetailbill'

import BrandReg from  '@/components/brandreg'

import VipCharge from  '@/components/person/vipcharge'

Vue.use(Router)
 
/*配置路由*/
export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {path: '/', name: 'Index', component: Index,meta: { title: '杭州电码科技有限公司，云验证' } },
    {path: '/main', name: 'Main', component: Main,meta: { title: '云验证--工作台' }},
    {path: '/top', name: 'Top', component: Top,meta: { title: 'top' }},
    {path: '/left', name: 'Left', component: Left,meta: { title: '菜单' }},
    {path: '/desktop', name: 'Desktop', component: Desktop,meta: { title: '云验证--工作台' }},
    {path: '/reg', name: 'Reg', component: Reg,meta: { title: '二办用户注册' }},
    {path: '/errorpage', name: 'ErrPage', component: ErrPage,meta: { title: '404错误' }},
    {path: '/txlcont', name: 'TxlCont', component: TxlCont,meta: { title: '通讯录' }},
    {path: '/txladd', name: 'TxlAdd', component: TxlAdd,meta: { title: '添加通讯录' }},
    {path: '/txlupload', name: 'TxlUpload', component: TxlUpload,meta: { title: '通讯录批量导入' }},
    {path: '/txlupload2', name: 'TxlUpload2', component: TxlUpload2,meta: { title: '通讯录批量导入' }},
    {path: '/txlgroup', name: 'TxlGroup', component: TxlGroup,meta: { title: '通讯录组管理' }},
    {path: '/TxlEdit', name: 'TxlEdit', component: TxlEdit,meta: { title: '通讯录编辑' }},
    {path: '/remind', name: 'Remind', component: Remind,meta: { title: '提醒' }},
    {path: '/remindadd', name: 'RemindAdd', component: RemindAdd,meta: { title: '新建提醒' }},
    {path: '/remindedit', name: 'RemindEdit', component: RemindEdit,meta: { title: '修改提醒' }},
    {path: '/memorandum', name: 'Memorandum', component: Memorandum,meta: { title: '记事待办/备忘录' }},
    {path: '/memorandumadd', name: 'MemorandumAdd', component: MemorandumAdd,meta: { title: '新增代办' }},
    {path: '/memorandumaddtx', name: 'MemorandumAddTX', component: MemorandumAddTX,meta: { title: '新增代办提醒' }},
    {path: '/memorandumedit', name: 'MemorandumEdit', component: MemorandumEdit,meta: { title: '修改代办' }},
    {path: '/memorandumtxedit', name: 'MemorandumTXEdit', component: MemorandumTXEdit,meta: { title: '修改代办提醒' }},
    {path: '/remindtype', name: 'RemindType', component: RemindType,meta: { title: '提醒类型管理' }},
    {path: '/enterprise', name: 'Enterprise', component: Enterprise,meta: { title: '企业管理' }},
    {path: '/enterpriseusermanage', name: 'EnterPriseUserManage', component: EnterPriseUserManage,meta: { title: '子账号管理' }},
    {path: '/enterprisexpaysuccess', name: 'EnterPriseXpaySuccess', component: EnterPriseXpaySuccess,meta: { title: '充值划账记录' }},
    {path: '/smssend', name: 'SmsSend', component: SmsSend,meta: { title: '发短信' }},
    {path: '/smsshortsend', name: 'SmsShortSend', component: SmsShortSend,meta: { title: '短地址群发' }},
    {path: '/smsmo', name: 'SmsMo', component: SmsMo,meta: { title: '短信收件箱/短信上行' }},
    {path: '/smsmtdaylog', name: 'SmsMtDayLog', component: SmsMtDayLog,meta: { title: '短信当日已发' }},
    {path: '/smsmtdaybeforelog', name: 'SmsMtDayBeforeLog', component: SmsMtDayBeforeLog,meta: { title: '短信昨天前天已发' }},
    {path: '/smsmtlog', name: 'SmsMtLog', component: SmsMtLog,meta: { title: '短信3天前已发' }},
    {path: '/smscheck', name: 'SmsCheck', component: SmsCheck,meta: { title: '短信审核' }},
    {path: '/smssavebox', name: 'SmsSaveBox', component: SmsSaveBox,meta: { title: '短信珍藏箱' }},
    {path: '/smsdraftbox', name: 'SmsDraftBox', component: SmsDraftBox,meta: { title: '短信草稿箱' }},
    {path: '/smsreachnotice', name: 'SmsReachNotice', component: SmsReachNotice,meta: { title: '收短信-通知设置' }},
    {path: '/smsconttxt', name: 'SmsContTxt', component: SmsContTxt,meta: { title: '短信群发库' }},
    {path: '/smsclassfiy', name: 'SmsClassFiy', component: SmsClassFiy,meta: { title: '短信库' }},
    {path: '/smsclassfiycontent', name: 'SmsClassFiyContent', component: SmsClassFiyContent,meta: { title: '短信库内容' }},
    {path: '/smsgexing', name: 'SmsGeXing', component: SmsGeXing,meta: { title: '个性短信' }},
    {path: '/smstools', name: 'SmsTools', component: SmsTools,meta: { title: '短信号码整理工具' }},
    {path: '/smssign', name: 'SmsSign', component: SmsSign,meta: { title: '短信签名管理' }},
    {path: '/smsmtsenderror', name: 'SmsMtSendError', component: SmsMtSendError,meta: { title: '异常短信列表' }},
    {path: '/showsmstxtcontent', name: 'ShowSmsTxtContent', component: ShowSmsTxtContent,meta: { title: '短信群发库文件内容查看' }},
    {path: '/smshistory', name: 'SmsHistory', component: SmsHistory,meta: { title: '短信历史记录' }},
    {path: '/bindmobile', name: 'BindMobile', component: BindMobile,meta: { title: '绑定手机号码' }},
    {path: '/llrecharge', name: 'LLRecharge', component: LLRecharge,meta: { title: '流量充值' }},
    {path: '/llrechargelog', name: 'LLRechargeLog', component: LLRechargeLog,meta: { title: '流量充值日志' }},
    {path: '/llrechargedetail', name: 'LLRechargeDetail', component: LLRechargeDetail,meta: { title: '流量充值记录明细' }},
    {path: '/emailsend', name: 'EmailSend', component: EmailSend,meta: { title: '发邮件' }},
    {path: '/emaillog', name: 'EmailLog', component: EmailLog,meta: { title: '已发送邮件' }},
    {path: '/emaillogdetail', name: 'EmailLogDetail', component: EmailLogDetail,meta: { title: '邮件详情' }},
    {path: '/emailconfig', name: 'EmailConfig', component: EmailConfig,meta: { title: '邮件发送设置' }},
    {path: '/emailhelp', name: 'EmailHelp', component: EmailHelp,meta: { title: '邮件发送帮助' }},
    {path: '/dialset', name: 'DialSet', component: DialSet,meta: { title: '点击通话设置' }},
    {path: '/dialsend', name: 'DialSend', component: DialSend,meta: { title: '点击通话' }},
    {path: '/diallog', name: 'DialLog', component: DialLog,meta: { title: '点击通话日志' }},
    {path: '/mmssend', name: 'MmsSend', component: MmsSend,meta: { title: '发送彩信' }},
    {path: '/mmscheck', name: 'MmsCheck', component: MmsCheck,meta: { title: '彩信审核' }},
    {path: '/mmscheckinfo', name: 'MmsCheckInfo', component: MmsCheckInfo,meta: { title: '彩信明细' }},
    {path: '/mmsdraft', name: 'MmsDraft', component: MmsDraft,meta: { title: '彩信草稿箱' }},
    {path: '/mmssendlog', name: 'MmsSendLog', component: MmsSendLog,meta: { title: '已发彩信' }},
    {path: '/mmssave', name: 'MmsSave', component: MmsSave,meta: { title: '珍藏彩信' }},
    {path: '/voicecodelog', name: 'VoiceCodeLog', component: VoiceCodeLog,meta: { title: '语音验证码日志' }},
    {path: '/personinfo', name: 'PersonInfo', component: PersonInfo,meta: { title: '用户信息' }},
    {path: '/passwordset', name: 'PasswordSet', component: PasswordSet,meta: { title: '密码设置' }},
    {path: '/account', name: 'Account', component: Account,meta: { title: '账户余额' }},
    {path: '/invoiceset', name: 'InvoiceSet', component: InvoiceSet,meta: { title: '发票申请' }},
    {path: '/invoicelog', name: 'InvoiceLog', component: InvoiceLog,meta: { title: '开票记录' }},
    {path: '/user106', name: 'User106', component: User106,meta: { title: '内容保证金' }},
    {path: '/chargeinfo', name: 'ChargeInfo', component: ChargeInfo,meta: { title: '充值信息' }},
    {path: '/usercoupon', name: 'UserCoupon', component: UserCoupon,meta: { title: '充值抵用券' }},
    {path: '/userpackage', name: 'UserPackage', component: UserPackage,meta: { title: '业务订购' }},
    {path: '/uservoucher', name: 'UserVoucher', component: UserVoucher,meta: { title: '优惠券充值' }},
    {path: '/chargeaccount', name: 'ChargeAccount', component: ChargeAccount,meta: { title: '充值' }},
    {path: '/youhui', name: 'YouHui', component: YouHui,meta: { title: '优惠' }},
    {path: '/fee', name: 'Fee', component: Fee,meta: { title: '资费表' }},
    {path: '/choujiang', name: 'ChouJiang', component: ChouJiang,meta: { title: '抽奖' }},
    // {path: '/qqtoken', name: 'QqToken', component: QqToken,meta: { title: 'qq绑定/登录' }},
    {path: '/uservip', name: 'UserVip', component: UserVip,meta: { title: 'VIP申请' }},
    {path: '/message', name: 'Message', component: Message, meta: { title: '投诉建议'}},
    {path: '/kefuindex', name: 'Kefuindex', component: Kefuindex, meta: { title: '客服帮助'}},
    {path: '/kefutop', name: 'Kefutop', component: Kefutop, meta: { title: '帮助top'}},
    {path: '/kefuleft', name: 'Kefuleft', component: Kefuleft, meta: { title: '帮助left'}},
    {path: '/contact', name: 'Contact', component: Contact, meta: { title: '联系方式'}},
    {path: '/introduce2office', name: 'Introduce2office', component: Introduce2office, meta: { title: '二办介绍'}},
    {path: '/useguide', name: 'Useguide', component: Useguide, meta: { title: '使用指南'}},
    {path: '/user_2office', name: 'User_2office', component: User_2office, meta: { title: '用户协议'}},
    {path: '/invoiceapply', name: 'InvoiceApply', component: InvoiceApply, meta: { title: '发票申请'}},
    {path: '/invoiceinformationmanage', name: 'InvoiceInformationManage', component: InvoiceInformationManage, meta: { title: '发票信息管理'}},
    {path: '/invoiceaddressmanage', name: 'InvoiceAddressManage', component: InvoiceAddressManage, meta: { title: '发票地址管理'}},
    {path: '/getpassword', name: 'GetPassword', component: GetPassword, meta: { title: '找回密码'}},
    {path: '/showallsystemmessage', name: 'ShowAllSystemMessage', component: ShowAllSystemMessage, meta: { title: '所有系统消息'}},
    {path: '/paysuccess', name: 'PaySuccess', component: PaySuccess, meta: { title: '支付成功'}},
    {path: '/checkemail', name: 'CheckEmail', component: CheckEmail, meta: { title: '邮箱验证'}},
    {path: '/qqlogin', name: 'QQLogin', component: QQLogin, meta: { title: 'QQ登录'}},
    {path: '/qqtoken', name: 'QQToken', component: QQToken, meta: { title: 'QQ安全账户登录'}},
    {path: '/qqbind', name: 'QQBind', component: QQBind, meta: { title: 'QQ绑定'}},
    {path: '/job_2office', name: 'Job_2office', component: Job_2office, meta: { title: '人才招聘'}},
    {path: '/productintroduction', name: 'ProductIntroduction', component: ProductIntroduction, meta: { title: '产品介绍'}},
    {path: '/productleft', name: 'ProductLeft', component: ProductLeft, meta: { title: '产品介绍左菜单'}},
    {path: '/wszj_introduction', name: 'WSZJ_Introduction', component: WSZJ_Introduction, meta: { title: '网商总机'}},
    {path: '/phone400introduction', name: 'Phone400', component: Phone400, meta: { title: '400电话'}},
    {path: '/smsmmsintroduction', name: 'SmsMmsIntroduction', component: SmsMmsIntroduction, meta: { title: '短信宝/彩信宝'}},
    {path: '/faxintroduction', name: 'FaxIntroduction', component: FaxIntroduction, meta: { title: '电子传真'}},
    {path: '/changhuabaointroduction', name: 'ChangHuaBaoIntroduction', component: ChangHuaBaoIntroduction, meta: { title: '长话宝'}},
    {path: '/meetingintroduction', name: 'MeetingIntroduction', component: MeetingIntroduction, meta: { title: '电话会议'}},
    {path: '/voicesmsintroduction', name: 'VoiceSmsIntroduction', component: VoiceSmsIntroduction, meta: { title: '语音短信'}},
    {path: '/apiintroduction', name: 'ApiIntroduction', component: ApiIntroduction, meta: { title: 'API介绍'}},
    {path: '/aboutus', name: 'AboutUs', component: AboutUs, meta: { title: '关于我们'}},
    {path: '/aboutusleft', name: 'AboutUsLeft', component: AboutUsLeft, meta: { title: '关于我们左侧菜单'}},
    {path: '/2officeintroduction', name: 'Introduction2Office', component: Introduction2Office, meta: { title: '云验证介绍'}},
    {path: '/alipayauth', name: 'AliPayAuth', component: AliPayAuth, meta: { title: '支付宝授权'}},
    {path: '/alipaylogin', name: 'AliPayLogin', component: AliPayLogin, meta: { title: '支付宝登录'}},
    {path: '/feeindex', name: 'FeeIndex', component: FeeIndex, meta: { title: '资费说明(首页)'}},
    {path: '/topindex', name: 'TopIndex', component: TopIndex, meta: { title: '介绍说明公共头部'}},
    {path: '/youhuiindex', name: 'YouHuiIndex', component: YouHuiIndex, meta: { title: '优惠划账(首页)'}},
    {path: '/productandfunctionintroduction', name: 'ProductAndFunction', component: ProductAndFunction, meta: { title: '产品及功能'}},
    {path: '/partners', name: 'Partners', component: Partners, meta: { title: '合作伙伴'}},
    {path: '/importantevents', name: 'ImportantEvents', component: ImportantEvents, meta: { title: '大事记'}},
    {path: '/kefu', name: 'Kefu', component: Kefu, meta: { title: '客服中心'}},
    {path: '/useguideindex', name: 'UseguideIndex', component: UseguideIndex, meta: { title: '使用指南(首页)'}},
    {path: '/kefuindexleft', name: 'KefuIndexLeft', component: KefuIndexLeft, meta: { title: '客服中心-左侧菜单'}},
    {path: '/dailihezuo', name: 'DaiLiHeZuo', component: DaiLiHeZuo, meta: { title: '代理合作'}},
    {path: '/alibaba_sms', name: 'albbSmsLogin', component: albbSmsLogin, meta: { title: '短信宝授权登录'}},
    {path:'/smsshorttask', name: 'SmsShortTask', component: SmsShortTask, meta: { title: '短地址群发任务'}},
    {path:'/smsshortvisit', name: 'SmsShortVisit', component: SmsShortVisit, meta: { title: '短地址访问记录'}},

    {path:'/alicrmlogin', name: 'AliCrmLogin', component: AliCrmLogin, meta: { title: '阿里crm登录'}},
    {path:'/alicrmreg', name: 'AliCrmReg', component: AliCrmReg, meta: { title: '阿里crm注册'}},
    {path:'/alicrmbind', name: 'AliCrmBind', component: AliCrmBind, meta: { title: '阿里crm绑定'}},

    {path: '/fyzx_login', name: 'fyzxLogin', component: fyzxLogin, meta: { title: '风云在线授权登录'}},
    {path: '/qrcodeimg', name: 'QrCodeImg', component: QrCodeImg, meta: { title: '微信二维码'}},
    {path: '/menutest', name: 'MenuTest', component: MenuTest, meta: { title: '菜单测试'}},
    {path: '/faxsend', name: 'FaxSend', component: FaxSend, meta: { title: '发传真'}},
    {path: '/faxcheck', name: 'FaxCheck', component: FaxCheck, meta: { title: '传真审核列表'}},
    {path: '/faxsendlog', name: 'FaxSendLog', component: FaxSendLog, meta: { title: '传真发送列表'}},
    {path: '/faxconttxt', name: 'FaxContTxt', component: FaxContTxt, meta: { title: '传真群发录'}},
    {path: '/showfaxtxtcontent', name: 'ShowFaxTxtContent', component: ShowFaxTxtContent, meta: { title: '群发录内容'}},
    {path: '/authenticationnumber', name: 'AuthenTicationNumber', component: AuthenTicationNumber, meta: { title: '号码认证'}},
    {path: '/authenticationnumbermanage', name: 'AuthenTicationNumberManage', component: AuthenTicationNumberManage, meta: { title: '号码认证管理'}},
    {path: '/chargeseconds400activity', name: 'ChargeSeconds400Activity', component: ChargeSeconds400Activity, meta: { title: '400号码秒杀付款'}},
    {path: '/seconds400paysuccess', name: 'Seconds400PaySuccess', component: Seconds400PaySuccess, meta: { title: '秒杀400号码成功'}},
    {path: '/seconds400activityrecord', name: 'Seconds400ActivityRecord', component: Seconds400ActivityRecord, meta: { title: '秒杀400号码列表'}},
    {path: '/videosmssend', name: 'VideoSmsSend', component: VideoSmsSend, meta: { title: '发送视频短信'}},
    {path: '/videosmstemplate', name: 'VideoSmsTemplate', component: VideoSmsTemplate, meta: { title: '视频短信模板'}},
    {path: '/videosmstemplateadd', name: 'VideoSmsTemplateAdd', component: VideoSmsTemplateAdd, meta: { title: '新增/修改视频短信模板'}},
    {path: '/videosmslog', name: 'VideoSmsLog', component: VideoSmsLog, meta: { title: '发送日志'}},
    {path: '/managewavfile', name: 'ManageWavFile', component: ManageWavFile, meta: { title: '语音文件管理'}},
    {path: '/sendmarketvoice', name: 'SendMarketVoice', component: SendMarketVoice, meta: { title: '发起云电销'}},
    {path: '/marketvoicedetailbill', name: 'MarketVoiceDetailBill', component: MarketVoiceDetailBill, meta: { title: '外呼记录'}},
    {path: '/brandreg', name: 'BrandReg', component: BrandReg, meta: { title: '商标注册介绍'}},
    {path: '/vipcharge', name: 'VipCharge', component: VipCharge, meta: { title: 'VIP用户续费'}},
  ]
})



// WEBPACK FOOTER //
// ./src/router/router.js